<template>
  <v-app id="inspire">
    <div v-if="pageType === 'intro'">
      <ServiceInit></ServiceInit>
    </div>
    <div v-else>
      <v-navigation-drawer
        v-model="drawer"
        :clipped="$vuetify.breakpoint.lgAndUp"
        app
        ref="appNavigation"
      >
        <v-list dense>
          <template v-for="item in items">
            <v-list-item
              :key="item.text"
              link
              :disabled="checkMenuDisabled(item)"
              @click.capture="checkVersionAlret($event)"
            >
              <router-link class="navigation-router-link" :to="item.toPath">
                <v-list-item-action>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    <p class="subtitle-2 mb-0">
                      {{ item.text }}
                    </p>
                  </v-list-item-title>
                </v-list-item-content>
              </router-link>
            </v-list-item>
          </template>
        </v-list>
      </v-navigation-drawer>
      <v-app-bar
        :clipped-left="$vuetify.breakpoint.lgAndUp"
        app
        color="blue darken-3"
        dark
        ref="appBar"
      >
        <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
        <v-toolbar-title style="width: 500px" class="ml-0 pl-4">
          <span class="hidden-sm-and-down hover" @click="moveHome()">{{
            appTitle
          }}</span>
        </v-toolbar-title>
        <v-spacer />
        <AppVersion></AppVersion>
      </v-app-bar>
      <v-content>
        <v-container class="height" fluid>
          <router-view></router-view>
        </v-container>
      </v-content>
    </div>
  </v-app>
</template>

<style scoped>
.navigation-router-link {
  color: unset;
  text-decoration: none;
  width: 100%;
  display: flex;
}
.v-list-item--disabled {
  pointer-events: auto;
}

.hover {
  cursor: pointer;
  text-decoration: none;
}
.hidden-sm-and-down.hover:hover {
  text-decoration: aliceblue;
  text-decoration-skip-ink: none;
  text-decoration: underline;
}
</style>

<script>
import "@/assets/style/common.css";
import ServiceInit from "@/views/mileage/ServiceInit.vue";
import AppVersion from "@/components/mileage/version/AppVersion.vue";

export default {
  data() {
    return {
      pageType: "intro",
      appTitle: null,
      drawer: null,
      unPlus: {
        color: "#8C8C8C",
      },
      items: [
        {
          icon: "mdi-home",
          text: "홈",
          toPath: `/mileage/${this.$store.state.mallId}/home`,
        },
        {
          icon: "mdi-file-powerpoint-box",
          text: "포인트 판매 설정",
          toPath: `/mileage/${this.$store.state.mallId}/sales_setting`,
        },
        {
          icon: "mdi-account-details",
          text: "포인트 주문 목록",
          toPath: `/mileage/${this.$store.state.mallId}/order`,
        },
        {
          icon: "mdi-clipboard-plus-outline",
          text: "부가서비스",
          toPath: `/mileage/${this.$store.state.mallId}/additional_service`,
        },
        {
          icon: "mdi-credit-card-outline",
          text: "결제 관리",
          toPath: `/mileage/${this.$store.state.mallId}/payment`,
          version: "all",
        },
      ],
    };
  },
  components: {
    ServiceInit,
    AppVersion,
  },
  methods: {
    checkVersionAlret: function(event) {
      let disabledEl = event.target.closest(".v-list-item--disabled");
      if (disabledEl !== null) {
        alert(
          "사용 기간이 만료되었습니다.\n결제 관리 메뉴에서 결제 후 사용이 가능합니다."
        );
        event.stopImmediatePropagation();
        event.preventDefault();
        event.stopPropagation();
      }
    },
    moveHome: function() {
      let mode = this.$store.state.mode;

      if (mode != "enabled") {
        if (
          this.$route.path == `/mileage/${this.$store.state.mallId}/payment`
        ) {
          return false;
        }
        this.$router.push({
          path: `/mileage/${this.$store.state.mallId}/payment`,
        });
      } else {
        this.$router.push({
          path: `/mileage/${this.$store.state.mallId}/home`,
        });
      }
    },
    checkMenuDisabled: function(item) {
      let mode = this.$store.state.mode;
      if (mode != "enabled") {
        if (item.version == "all") {
          return false;
        }
        item.toPath = "";
        return true;
      } else {
        return false;
      }
    },
  },
  created: function() {
    document.title = "포인트 판매 서비스";
    this.appTitle = `[ ${this.$store.state.mallName} ] 포인트 판매 서비스`;
    const url_path = window.location.pathname;
    this.pageType = url_path === "/mileage/init" ? "intro" : "page";
  },
};
</script>
